import { render } from "./JobReported.vue?vue&type=template&id=b5a02f7e&scoped=true"
import script from "./JobReported.vue?vue&type=script&lang=js"
export * from "./JobReported.vue?vue&type=script&lang=js"

import "./JobReported.vue?vue&type=style&index=0&id=b5a02f7e&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5a02f7e"]])

export default __exports__